import { Logos } from "../../../tokens/ts/_logos";
import { kebabToJS } from "../../../_utilities";

const convertLogo = (logo: Element) => {
  const name = kebabToJS(logo.classList[1].replace("logo-", ""));
  const svg = (<any>Logos)[name];
  const svgElementContainer = document.createElement("div");
  svgElementContainer.innerHTML = svg;
  const svgElement = svgElementContainer.childNodes[0] as any;
  svgElement.removeAttribute("height");
  svgElement.removeAttribute("width");
  if (!svgElement.getAttribute("preserveAspectRatio")) {
    svgElement.setAttribute("preserveAspectRatio", "xMinYMid meet");
  }
  if (logo.id) {
    svgElement.id = logo.id;
  }
  svgElement.classList = logo.classList;

  if (logo.classList.contains("logo--unwrapped")) {
    logo.parentNode.replaceChild(svgElement, logo);
  } else {
    logo.appendChild(svgElement);
  }
};

export const init = (logoElement?: Element): void => {
  if (logoElement) return convertLogo(logoElement);
  document.querySelectorAll("[class^='logo']").forEach((logo) => {
    convertLogo(logo);
  });
};

export default {
  init,
};
